<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('bill.view.title')"
      :visible="visible"
      width="960px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <p class="item-title">{{$t('bill.view.detail')}}</p>
        <div class="order-info">
          <ul>
            <li>
              <p class="lable-text">{{$t('bill.view.tNumber')}}</p>
              <p>{{sn}}</p>
            </li>
            <li>
              <p class="lable-text">{{$t('bill.view.oType')}}</p>
              <p>{{product_code}}</p>
            </li>
            <li>
              <p class="lable-text">{{$t('bill.view.otime')}}</p>
              <p>{{create_time}}</p>
            </li>

            <li>
              <p class="lable-text">{{$t('bill.view.ptime')}}</p>
              <p v-if="pay_time != '0'">{{pay_time}}</p>
              <p v-else>-</p>
            </li>
          </ul>
        </div>
        <p class="item-title">{{$t('bill.view.odetail')}}</p>
        <div class="order-table">
          <el-table :data="tableData" v-loading="loading" height="250" style="width: 100%">
            <el-table-column prop="Product" :label="$t('bill.view.product')"> </el-table-column>
            <el-table-column prop="Quantuty" :label="$t('bill.view.num')">
            </el-table-column>
            <el-table-column prop="config" :label="$t('bill.view.config')" width="280">
            </el-table-column>
            <el-table-column prop="price" :label="$t('bill.view.price')">
              <template slot-scope="scope">
                <p>{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.price) }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="pay_amount" :label="$t('bill.view.pamount')">
              <template slot-scope="scope">
                <p>{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.pay_amount) }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">Close</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
        create_time:'',
        sn:'',
        product_code:'',
        pay_time:'',
      visible: false,
      tableData: [
        // {
        //   product: "Cloud Server",
        //   quantuty: "2",
        //   config: "CPU: 2vCores  RAM:4G  Bandwidth:2M",
        //   unitPrice: "$ 20.25 / Month",
        //   charge: "$ 20.25",
        // }
      ],
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
        this.create_time='';
        this.sn='';
        this.product_code='';
        this.pay_time='';
        this.tableData=[];
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange(sn) {
      this.visible = !this.visible;
      this.getInfo(sn);
    },
    getInfo(sn){
      this.loading = true;
        this.$http.post('/home/billing/orderInfo', {orderSn:sn}).then((res) => {
          this.loading = false;
            res = res.data.data;
            this.tableData = res.detail;
            this.create_time=res.create_time;
            this.sn=res.sn;
            this.product_code=res.product_code;
            this.pay_time=res.pay_time;
        }).catch((err) => {
            this.$util.handleErr(err);
        })
    }
  },
};
</script>

<style scoped lang="scss">
.item-title {
  font-size: 14px;
  font-weight: 500;
  color: #0f1e33;
  line-height: 14px;
  margin-bottom: 18px;
}
.order-info {
  padding: 32px 24px;
  background: #f5f7fa;
  margin-bottom: 32px;
  ul {
    display: grid;
    grid-template-columns: repeat(2, 45%);
    grid-gap: 24px;
    li {
      padding-left: 130px;
      position: relative;
      p.lable-text {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        color: #5e6d81;
      }
      p:nth-child(2) {
        font-size: 14px;
        color: #0f1e33;
      }
    }
  }
}
.order-table {
  padding: 32px 23px;
  background: #f5f7fa;
}
</style>
<style lang="scss">
.order-table {
  .el-table__body-wrapper {
    background: #f5f7fa;
  }
  .el-table--border {
    border: 1px solid #dbe1e8;
  }
  .el-table th {
    background: #ffffff;
  }
  .el-table td {
    background: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/ViewOrder.vue